import ifNotTrueExecute from 'utils/ifNotTrueExecute'

function getValidValues(controllers, validateOnError = false) {
  const formValues = {}
  let isValidForm = true

  if (controllers) {
    Object.keys(controllers).forEach(key => {
      const status = controllers[key].getStatus()
      if (validateOnError) {
        ifNotTrueExecute(status.valid, controllers[key].validate)
      }
      isValidForm = isValidForm && status.valid
      if (status.value) {
        formValues[key] = status.value
      }
    })
  }

  return {
    formValues,
    isValidForm
  }
}

export default getValidValues
